import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useConfirmMission, useRejectMission, usePendingMissionConfirmations } from "@/hooks/use-kid-missions";
import type { Id } from "../../../convex/_generated/dataModel";

export function MissionConfirmCard() {
  const { data: pending, isLoading } = usePendingMissionConfirmations();
  const { mutateAsync: confirm, isPending: isConfirming } = useConfirmMission();
  const { mutateAsync: reject, isPending: isRejecting } = useRejectMission();

  if (isLoading || !pending || pending.length === 0) return null;

  return (
    <Card className="border-2 border-amber-300 bg-amber-50">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2">
          <span>🎾</span>
          Mission Check-In
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {pending.map((item) => (
          <div
            key={item.completionId}
            className="bg-white rounded-xl p-4 border border-amber-200 space-y-3"
          >
            <p className="text-sm text-gray-700">
              <span className="font-semibold">{item.playerFirstName}</span> says
              they completed:
            </p>
            <div className="flex items-center gap-2">
              <span className="text-2xl">{item.missionEmoji}</span>
              <p className="font-semibold text-gray-900">{item.missionTitle}</p>
            </div>
            <div className="flex gap-2">
              <Button
                size="sm"
                className="flex-1 bg-emerald-500 hover:bg-emerald-600 text-white"
                disabled={isConfirming || isRejecting}
                onClick={() =>
                  confirm({
                    completionId: item.completionId as Id<"missionCompletions">,
                  })
                }
              >
                ✅ Yes, they did it!
              </Button>
              <Button
                size="sm"
                variant="outline"
                className="flex-1"
                disabled={isConfirming || isRejecting}
                onClick={() =>
                  reject({
                    completionId: item.completionId as Id<"missionCompletions">,
                  })
                }
              >
                ❌ Not yet
              </Button>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
